import React from "react";
import ChatRoomTemplate from "../components/template/ChatRoomTemplate";

function ChatRoom() {
  return (
    <>
      <ChatRoomTemplate />
    </>
  );
}

export default ChatRoom;
